import inventoryAPI from '@/services/api/inventory'
import SortUtil from '@/utils/modules/SortUtil'

const inventory = {
	namespaced: true,
	state: () => ({
		count: undefined,
		inventoryList: undefined,
		offset: 0,
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		length: 10,
		sortType: 1, // 1: 등록일순, 2: 이름순, 3: 위치 및 보관함,
		filter: {
			keyword: '',
			registerMethods: [],
			categoriesId: [],
			storagesId: [],
			assigneesId: [],
			brandsId: [],
			expireDate: [],
			currentVolume: [],
			status: [],
			legalsId: [],
		},
		unit: undefined,
	}),
	getters: {
		getFilterRegisterMethodsCount: state => {
			const count = state.filter.registerMethods.length
			return count === 0 ? '' : count
		},
		getFilterStatusCount: state => {
			const count = state.filter.status.length
			return count === 0 ? '' : count
		},
		getFilterAssigneesCount: state => {
			const count = state.filter.assigneesId.length
			return count === 0 ? '' : count
		},
		getFilterCategoriesCount: state => {
			const count = state.filter.categoriesId.length
			return count === 0 ? '' : count
		},
		getFilterStoragesCount: state => {
			const count = state.filter.storagesId.length
			return count === 0 ? '' : count
		},
		getGroupingKey: state => {
			const filteredData = []
			if (state.inventoryList) {
				for (
					let listIdx = 0;
					listIdx < state.inventoryList.length;
					listIdx++
				) {
					const item = state.inventoryList[listIdx]
					switch (state.sortType) {
						case 1:
							filteredData.push(item.createDatetime.substr(0, 10))
							break
						case 2:
							if (item.name) {
								filteredData.push(
									SortUtil.getKorChosung(
										item.name.substr(0, 1)
									).toUpperCase()
								)
							}
							break
						case 3:
							const { location, storage } = item
							filteredData.push(
								SortUtil.makeFullStoragePath(
									location.pathName,
									storage.pathName
								)
							)
							break
					}
				}
			}
			const removeDuplicateData = [...new Set([...filteredData])]
			return removeDuplicateData
		},
		getInventoryAsFilter: state => {
			// 인벤토리 데이터 자료구조를 변경하는 getter
			const filteredData = []
			const result = {}

			if (state.inventoryList) {
				for (
					let listIdx = 0;
					listIdx < state.inventoryList.length;
					listIdx++
				) {
					const item = state.inventoryList[listIdx]
					switch (state.sortType) {
						case 1:
							filteredData.push(item.createDatetime.substr(0, 10))
							break
						case 2:
							if (item.name) {
								filteredData.push(
									SortUtil.getKorChosung(
										item.name.substr(0, 1)
									).toUpperCase()
								)
							}
							break
						case 3:
							const { location, storage } = item
							filteredData.push(
								SortUtil.makeFullStoragePath(
									location.pathName,
									storage.pathName
								)
							)
							break
					}
				}

				const removeDuplicateData = [...new Set([...filteredData])]

				for (let idx = 0; idx < removeDuplicateData.length; idx++) {
					const dataKey = removeDuplicateData[idx]
					result[dataKey] = state.inventoryList.filter(item => {
						let filterFunction = () => {}
						switch (state.sortType) {
							case 1:
								filterFunction =
									item.createDatetime.substr(0, 10) ===
									dataKey
								break
							case 2:
								if (item.name) {
									filterFunction =
										SortUtil.getKorChosung(
											item.name.substr(0, 1).toUpperCase()
										) === dataKey
								}
								break
							case 3:
								const { location, storage } = item
								filterFunction =
									SortUtil.makeFullStoragePath(
										location.pathName,
										storage.pathName
									) === dataKey
								break
						}
						return filterFunction
					})
				}
			}

			return result
		},
	},
	mutations: {
		setInventoryListCount: (state, payload) => {
			state.count = payload
		},
		setInventoryList: (state, payload) => {
			state.inventoryList = payload
		},
		setSearchInventoryList: (state, payload) => {
			state.searchInventoryList = payload
		},
		setInventorySortType: (state, payload) => {
			state.sortType = payload
			switch (payload) {
				case 1:
					state.order = ['CREATE_DATETIME']
					state.orderDirection = ['DESC']
					break
				case 2:
					state.order = ['NAME']
					state.orderDirection = ['ASC']
				case 3:
					state.order = ['STORAGE']
					state.orderDirection = ['ASC']
					break
			}
		},
		setOrder: (state, payload) => {
			state.order = payload
		},
		setOrderDirection: (state, payload) => {
			state.orderDirection = payload
		},
		setKeyword: (state, payload) => {
			state.filter.keyword = payload
		},
		setRegisterMethods: (state, payload) => {
			state.filter.registerMethods = [...payload]
		},
		setCategoriesId: (state, payload) => {
			state.filter.categoriesId = [...payload]
		},
		setStoragesId: (state, payload) => {
			state.filter.storagesId = payload
		},
		setAssigneesId: (state, payload) => {
			state.filter.assigneesId = [...payload]
		},
		setBrandsId: (state, payload) => {
			state.filter.brandsId = payload
		},
		setExpireDate: (state, payload) => {
			state.filter.expireDate = payload
		},
		setCurrentVolume: (state, payload) => {
			state.filter.currentVolume = payload
		},
		setLegalsId: (state, payload) => {
			state.filter.legalsId = payload
		},
		setInitFilter: state => {
			state.filter = {
				keyword: '',
				registerMethods: [],
				categoriesId: [],
				storagesId: [],
				assigneesId: [],
				brandsId: [],
				expireDate: [],
				currentVolume: [],
				status: [],
				legalsId: [],
			}
		},
		setOffset: (state, payload) => {
			state.offset = payload
		},
		addInventoryList: (state, payload) => {
			state.inventoryList = [...state.inventoryList, ...payload]
		},
		setStatus: (state, payload) => {
			state.filter.status = [...payload]
		},
		setFilter: (state, payload) => {
			state.filter = payload
		},
	},
	actions: {
		clearInventoryList: ({ commit }) => {
			commit('setInventoryList', [])
			commit('setInventoryListCount', undefined)
		},
		loadInventoryList: async ({ commit, state }, payload) => {
			const { instId, type } = payload
			const {
				keyword,
				registerMethods,
				categoriesId,
				storagesId,
				assigneesId,
				brandsId,
				expireDate,
				currentVolume,
				status,
				legalsId,
			} = state.filter
			commit('setOffset', 0)

			const params = {
				offset: state.offset,
				length: state.length,
				order: state.order,
				orderDirection: state.orderDirection,
				keyword: keyword,
				registerMethods: registerMethods,
				categoriesId: categoriesId,
				storagesId: storagesId,
				assigneesId: assigneesId,
				brandsId: brandsId,
				expireDate: expireDate,
				statue: status,
			}

			if (type === 'legal') {
				params.legalsId = legalsId
			}

			const response = await inventoryAPI.lookupInventoryList(
				instId,
				params
			)
			commit('setInventoryList', response.data.list)
			commit('setInventoryListCount', response.data.count)
		},
		addInventoryList: async ({ commit, state }, payload) => {
			const { instId } = payload
			const {
				keyword,
				registerMethods,
				categoriesId,
				storagesId,
				assigneesId,
				brandsId,
				expireDate,
				currentVolume,
				status,
			} = state.filter

			const params = {
				offset: state.offset,
				length: state.length,
				order: state.order,
				orderDirection: state.orderDirection,
				keyword: keyword,
				registerMethods: registerMethods,
				categoriesId: categoriesId,
				storagesId: storagesId,
				assigneesId: assigneesId,
				brandsId: brandsId,
				expireDate: expireDate,
				currentVolume: currentVolume,
				statue: status,
			}

			const response = await inventoryAPI.lookupInventoryList(
				instId,
				params
			)
			commit('addInventoryList', response.data.list)
		},
	},
}
export default inventory
